import { render, staticRenderFns } from "./custompage.vue?vue&type=template&id=078dafcb"
import script from "./custompage.vue?vue&type=script&lang=js"
export * from "./custompage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports